import naIcon from '../../assets/svg/na.svg';
import aiSummaryIcon from '../../assets/svg/themed/ai-summary.svg';
import barIcon from '../../assets/svg/themed/bar.svg';
import boxIcon from '../../assets/svg/themed/box.svg';
import chordIcon from '../../assets/svg/themed/chord.svg';
import distributionIcon from '../../assets/svg/themed/distribution.svg';
import divergingBarIcon from '../../assets/svg/themed/diverging-bar.svg';
import divergingBarComboIcon from '../../assets/svg/themed/diverging-bar-combo.svg';
import gaugeIcon from '../../assets/svg/themed/gauge.svg';
import groupedBarIcon from '../../assets/svg/themed/grouped-bar.svg';
import icicleIcon from '../../assets/svg/themed/icicle.svg';
import lineIcon from '../../assets/svg/themed/line.svg';
import mapIcon from '../../assets/svg/themed/map.svg';
import sankeyIcon from '../../assets/svg/themed/sankey.svg';
import stackedBarIcon from '../../assets/svg/themed/stacked-bar.svg';
import tableIcon from '../../assets/svg/themed/table.svg';
import textIcon from '../../assets/svg/themed/text.svg';
import treemapIcon from '../../assets/svg/themed/treemap.svg';
import volumeIcon from '../../assets/svg/themed/volume.svg';
import type { SelectableChartType } from '../PageConfigProvider/types/chart';
import styles from './chart-icon.module.css';

const iconMap: Record<SelectableChartType, string> = {
  bar: barIcon,
  map: mapIcon,
  'stacked-bar': stackedBarIcon,
  'grouped-bar': groupedBarIcon,
  'diverging-bar': divergingBarIcon,
  'diverging-bar-combo': divergingBarComboIcon,
  treemap: treemapIcon,
  line: lineIcon,
  'gauge-v2': gaugeIcon,
  table: tableIcon,
  text: textIcon,
  'ai-summary': aiSummaryIcon,
  sankey: sankeyIcon,
  chord: chordIcon,
  distribution: distributionIcon,
  volume: volumeIcon,
  box: boxIcon,
  icicle: icicleIcon,
};

export const ChartIcon = ({ type }: { type: SelectableChartType }) => {
  return (
    <div className={styles.icon}>
      <img className={styles.image} src={iconMap[type]} alt={`${type} icon`} />
    </div>
  );
};

export const NonSelectableChartIcon = () => {
  return (
    <div className={styles.icon}>
      <img className={styles.image} src={naIcon} alt="na icon" />
    </div>
  );
};
